module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-300.26dc973f.woff";